import { render } from "./PostCategoryDetail.vue?vue&type=template&id=55c4b258"
import script from "./PostCategoryDetail.vue?vue&type=script&lang=js"
export * from "./PostCategoryDetail.vue?vue&type=script&lang=js"

import "./PostCategoryDetail.vue?vue&type=style&index=0&id=55c4b258&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__